// extracted by mini-css-extract-plugin
export default {"wrapper":"TextArea_wrapper__JivEh","textarea":"TextArea_textarea__UuJEZ","hint":"TextArea_hint__IatSi"};